import Model    from "./Model";
import Media    from "./Media";
import User     from "./User";
import City     from "./City";
import Sector     from "./Sector";
import Presentation     from "./SupplierPresentation";

export default class Supplier extends Model
{
    constructor( options = {} )
    {
        super(null);

        this.setOptions(options);
    }

    setOptions( options = {} )
    {
        this.id         = options.id                || null;
        this.user       = new User(options.user     || {});
        this.name       = options.name              || null;
        this.logo       = options.logo              || null;
        this.logoUrl    = options.logoUrl           || null;
        this.photo      = new Media(options.photo   || {});
        this.web        = options.web               || null;
        this.sector     = new Sector(options.sector || {});
        this.address    = options.address           || null;
        this.zip        = options.zip               || null;
        this.city       = new City(options.city     || {});
        this.phone      = options.phone             || null;
        this.email      = options.email             || null;
        this.presentation = new Presentation(options.presentation   || {});
        this.cities     = options.cities ? City.makeCollection(options.cities) : [];
        this.created_at = new moment(options.created_at     || {});
        this.permalink  = options.permalink;
    }

    toJson ()
    {
        return {
            id          : this.id,
            user        : this.user.toJson(),
            name        : this.name,
            logo        : this.logo,
            logoUrl     : this.logoUrl,
            photo       : this.photo.toJson(),
            web         : this.web,
            sector      : this.sector.toJson(),
            address     : this.address,
            zip         : this.zip,
            city        : this.city.toJson(),
            phone       : this.phone,
            email       : this.email,
            presentation: this.presentation.toJson(),
            created_at  : this.created_at ? this.created_at.format("YYYY-MM-DD") : null,
            permalink   : this.permalink,
        }
    }
}


// WEBPACK FOOTER //
// ./resources/js/models/Supplier.js